module.exports = __webpack_public_path__ + "static/media/logo_horizontal.c1b969e3.png";